import { type FC, type ReactNode } from "react";
import { Form, type FormInstance } from "antd";
import TrailInfoComponent from "../TrialInfoComponent/index";
import PlotDesignComponent from "../plotDesignComponent";
import RatesDosageComponent from "../ratesDosageComponent";
import SummaryComponent from "../SummaryComponent";
import FormNavigationButtons from "./FormNavigationButtons";

export interface TrialFormProps {
  form: FormInstance<any>;
  current: number;
  trialData: any;
  onFormFinish: (...args: any[]) => void;
  cancelLabel: string;
  nextLabel: string;
  isStepValid: boolean;
  isNextDisabled: boolean;
  onCancelClick: () => void;
  onNextClick: () => void;
  onSavePlotDesign?: () => Promise<boolean>;
  onPrepareRatesAndDosage?: () => Promise<void>;
  ratesDosageContent?: ReactNode;
}

const renderStepContent = (
  current: number,
  trialData: any,
  form: FormInstance<any>,
  ratesDosageContent?: ReactNode
): ReactNode => {
  switch (current) {
    case 0:
      return <TrailInfoComponent trialData={trialData} form={form} />;
    case 1:
      return <PlotDesignComponent trialData={trialData} />;
    case 2:
      return (
        ratesDosageContent ?? <RatesDosageComponent trialData={trialData} />
      );
    case 3:
      return <SummaryComponent />;
    default:
      return null;
  }
};

const TrialForm: FC<TrialFormProps> = ({
  form,
  current,
  trialData,
  onFormFinish,
  cancelLabel,
  nextLabel,
  isStepValid,
  isNextDisabled,
  onCancelClick,
  onNextClick,
  onSavePlotDesign,
  onPrepareRatesAndDosage,
  ratesDosageContent,
}) => {
  return (
    <Form
      data-testid="form-basic"
      name="basic"
      onFinish={onFormFinish}
      form={form}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
        }
      }}
      layout="vertical"
    >
      <div className={current === 3 ? "scroll-sec-3" : "scroll-sec"}>
        {renderStepContent(current, trialData, form, ratesDosageContent)}
      </div>
      {current !== 3 && !(current === 2 && ratesDosageContent) && (
        <FormNavigationButtons
          current={current}
          cancelLabel={cancelLabel}
          nextLabel={nextLabel}
          isStepValid={isStepValid}
          isNextDisabled={isNextDisabled}
          onCancelClick={onCancelClick}
          onNextClick={onNextClick}
          onSavePlotDesign={onSavePlotDesign}
          onPrepareRatesAndDosage={onPrepareRatesAndDosage}
        />
      )}
    </Form>
  );
};

export default TrialForm;
